import React from 'react'
import { Events, HelpSupport, Hotel, Location, Logout, Notification, PaymentMethod, SampleUser, Setting, Subscription, Wallet } from '../../assests/ExportImageIcon'

const PROFILE_MENU = [
    { icon: Location, label: 'My Trips', key: 'trips' },
    { icon: 'groups', label: 'Groups', key: 'groups' },
    { icon: Events, label: 'My Events', key: 'events' },
    { icon: Hotel, label: 'My Venues', key: 'venues' },
    { icon: 'rfp', label: 'My RFPs', key: 'rfps' },
    { icon: Wallet, label: 'My Wallet', key: 'wallet' },
    // { icon: PaymentMethod, label: 'Payment Method' },
    // { icon: Notification, label: 'Notifications' },
    { icon: Subscription, label: 'My Subscription', key: 'subscription' },
    { icon: 'shield', label: 'Privacy & Security', key: 'privacy' },
    { icon: HelpSupport, label: 'Help & Support', key: 'help-support' },
    // { icon: 'rating', label: 'Rating & Reviews', key: 'rating-reviews' },
    { icon: Setting, label: 'Settings', key: 'settings' },
]

const ShieldIcon = () => (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
        <path d="M10 1.66667L16.6667 4.16667V9.16667C16.6667 13.0917 13.8517 16.7417 10 18.3333C6.14833 16.7417 3.33333 13.0917 3.33333 9.16667V4.16667L10 1.66667Z" stroke="#026D4D" strokeWidth="1.5" strokeLinejoin="round" />
    </svg>
)

const GroupsIcon = () => (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
        <path d="M7.5 9.16667C8.88071 9.16667 10 8.04738 10 6.66667C10 5.28596 8.88071 4.16667 7.5 4.16667C6.11929 4.16667 5 5.28596 5 6.66667C5 8.04738 6.11929 9.16667 7.5 9.16667Z" stroke="#026D4D" strokeWidth="1.5" strokeLinejoin="round" />
        <path d="M2.5 16.6667C2.5 13.9052 4.73858 11.6667 7.5 11.6667C10.2614 11.6667 12.5 13.9052 12.5 16.6667" stroke="#026D4D" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M13.3333 4.29199C14.5391 4.62958 15.4167 5.73641 15.4167 7.04199C15.4167 8.34757 14.5391 9.4544 13.3333 9.79199" stroke="#026D4D" strokeWidth="1.5" strokeLinecap="round" />
        <path d="M14.1667 11.9082C16.0446 12.5323 17.5 14.1174 17.5 16.6666" stroke="#026D4D" strokeWidth="1.5" strokeLinecap="round" />
    </svg>
)

const RfpIcon = () => (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
        <path d="M5 2.5h7.5L17.5 7.5V17.5H5V2.5Z" stroke="#026D4D" strokeWidth="1.5" strokeLinejoin="round" />
        <path d="M12.5 2.5V7.5H17.5" stroke="#026D4D" strokeWidth="1.5" strokeLinejoin="round" />
        <path d="M7.5 11h5M7.5 14h5" stroke="#026D4D" strokeWidth="1.5" strokeLinecap="round" />
    </svg>
)

const RatingIcon = () => (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
        <path d="M10 1.66667L12.5729 6.87833L18.3333 7.72083L14.1667 11.78L15.1458 17.5167L10 14.8117L4.85417 17.5167L5.83333 11.78L1.66667 7.72083L7.42708 6.87833L10 1.66667Z" stroke="#026D4D" strokeWidth="1.5" strokeLinejoin="round" />
    </svg>
)

const ChevronArrow = () => (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
        <path d="M6 4l4 4-4 4" stroke="#026D4D" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
)

const ProfileSidebar = ({
    activeSection = 'profile',
    onSelect,
    onEditProfile,
    onLogout,
    loggingOut = false,
    name = 'User',
    email = '—',
    avatarUrl = '',
}) => {
    const handleUserClick = () => {
        if (onEditProfile) {
            onEditProfile()
            return
        }
        onSelect?.('profile')
    }

    return (
        <div className='profileSIdebar'>
            <div
                className='profileUser'
                role='button'
                tabIndex={0}
                onClick={handleUserClick}
                onKeyDown={(e) => {
                    if (e.key === 'Enter' || e.key === ' ') handleUserClick()
                }}
            >
                <img
                    src={avatarUrl || SampleUser}
                    alt=""
                    className='profileUser__avatar'
                    onError={(e) => {
                        if (e.currentTarget.src !== SampleUser) e.currentTarget.src = SampleUser
                    }}
                />
                <div className='profileUser__info'>
                    <div className='profileUser__name'>{name || 'User'}</div>
                    <div className='profileUser__email'>{email || '—'}</div>
                </div>
                <ChevronArrow />
            </div>

            <ul className='profileMenu'>
                {PROFILE_MENU.map((item, index) => (
                    <li
                        className={`profileMenu__item ${item.key && activeSection === item.key ? 'active' : ''}`}
                        key={index}
                        onClick={item.key && onSelect ? () => onSelect(item.key) : undefined}
                    >
                        {item.icon === 'shield' ? <ShieldIcon /> : item.icon === 'rfp' ? <RfpIcon /> : item.icon === 'groups' ? <GroupsIcon /> : item.icon === 'rating' ? <RatingIcon /> : <img src={item.icon} alt="" />}
                        <span>{item.label}</span>
                        <ChevronArrow />
                    </li>
                ))}
                <li
                    className='profileMenu__item profileMenu__item--danger'
                    onClick={loggingOut ? undefined : onLogout}
                    style={loggingOut ? { opacity: 0.6, pointerEvents: 'none' } : undefined}
                >
                    <img src={Logout} alt="" />
                    <span>{loggingOut ? 'Logging out...' : 'Logout'}</span>
                </li>
            </ul>
        </div>
    )
}

export default ProfileSidebar
